export const en = {
    'add-correction': 'New adjustment',
    'choose-all-retargeting-conditions': 'All retargeting lists',
    'demography-title': 'Gender and age of user',
    'device-title': 'Device type',
    'flat-mass-rate-control': 'Common bid for bid adjustment',
    'inventory-title': 'Type of inventory',
    'mass-rate-control': 'Bid {control} %',
    'no-items-message': 'Bid adjustments not set.',
    'retargeting-edit-link': 'Criteria settings',
    'retargeting-title': 'Retargeting & Audiences',
    'same-values-for-all-rate-control': 'Set the same value for all conditions',
    'smart-banners-title': 'Bid settings for automatically-created smart ads',
    'traffic-jam-hint':
        'Adjustments use data from Yandex.Maps. For outdoor advertising, the traffic situation in front of the advertising surface is taken into account.',
    'traffic-jam-title': 'Adjustments based on traffic conditions',
    'video-addition-title': 'Bid settings for ads with video extensions',
    'weather-title': 'Weather adjustments'
};
